/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import * as Yup from 'yup';

import i18n from '@dms/i18n';
import {CebiaAutotracerAndReportCredentials} from '@dms/teas';

export const cebiaAuthValidations = (): Yup.SchemaOf<CebiaAutotracerAndReportCredentials> =>
  Yup.object().shape({
    username: Yup.string().required(i18n.t('general.validations.fieldIsRequired')),
    password: Yup.string().required(i18n.t('general.validations.fieldIsRequired')),
  });
